import { createRoot, type Root } from 'react-dom/client';
import { autoBeforeEachTest } from '@jira/platform__utils-auto-before-each-test/src/auto-before-each-test.tsx';

// The dwell-time placeholder is rendered from `src/entry/render-dwell-time` and unmounted from
// `SessionTracker` in this package, so the React 19 root must be tracked here where both sides
// can reach it.
let roots = new WeakMap<Element, Root>();
autoBeforeEachTest(() => {
	roots = new WeakMap();
});

export const getOrCreateDwellTimeRoot = (container: Element): Root => {
	let root = roots.get(container);
	if (!root) {
		root = createRoot(container);
		roots.set(container, root);
	}
	return root;
};

export const unmountDwellTimeRoot = (container: Element): void => {
	const root = roots.get(container);
	if (root) {
		root.unmount();
		roots.delete(container);
	}
};
